import React, { useState } from 'react';
import Button from '../global/Button';
import questionIcon from '../../assets/icons/DashboardIcons/question.svg';

type TotalSettlementCardProps = {
  label: string;
  value: string;
  icon: string;
  hint?: string;
};
const TotalSettlementCard = ({ label, value, icon, hint }: TotalSettlementCardProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className='sm:border-[#DDDDDD] rounded-md border mt-3 mb-3 py-3 px-3'>
      <div className='space-y-4'>
        <div className='flex items-center pl-1 justify-between space-x-3'>
          <div className='flex items-center pl-1 justify-between   space-x-3'>
            <img src={icon} alt={icon} />
            <h2 className='font-normal font-poppins text-sm text-[#212121]'>{label}</h2>
          </div>

          <div className='flex flex-col items-end relative gap-2'>
            <div
              className='hidden md:block cursor-pointer'
              onClick={() => setShowTooltip(!showTooltip)}
            >
              <img src={questionIcon} alt='bar-icon' />
            </div>
            {showTooltip && (
              <div className='w-[248px] h-[103px] top-6 absolute z-50 justify-end transition-all pb-1 bg-white rounded-md shadow-smYellow'>
                <p className='font-poppins text-xs  pt-2 pl-3 pr-6 '>{hint}</p>
                <div className='flex justify-end pr-4 pt-[6px] '>
                  <button
                    onClick={() => setShowTooltip(!showTooltip)}
                    className='text-green font-normal text-xs font-poppins'
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='flex pt-[28px] justify-between'>
          <div className='flex items-center justify-center '>
            <h3 className='text-[13px] font-poppins flex bg-[#049E2621] p-[3px] text-green'>
              NGR{' '}
            </h3>
            <span className='text-[27px] font-poppins  tracking-tighter pl-[6px] font-medium'>
              {value}
            </span>
          </div>
        </div>
        <div>
          <p className='text-[#212121] font-poppins font-normal text-[9.95px]'>
            Add product and start selling to get a settlement.
          </p>
        </div>
        <Button className='text-xs !px-4 !py-2'>See all settlements</Button>
      </div>
    </div>
  );
};

export default TotalSettlementCard;
